module.exports = __webpack_public_path__ + "img/t1-social-links.0a486186.png";